// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import { _debounce, execPluginsFetch } from "utils"
// 注册必须的组件
import eventMixin from "utils/event/eventMixin.js"
import parentMixinCommon from "components/bigScreenComponents/common"
export default {
  mixins: [eventMixin, parentMixinCommon],
  props: {
    options: null,
    myid: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      showChart: true,
      refreshedChart: true,
      timeTicket: null,
      animateTimer: null,
      reloadTimer: null
    }
  },
  watch: {
    "$store.state.states.dragMode"(n, o) {
      setTimeout(() => {
        if (
          (n && this?.options?.chartOption?.formatterEv) ||
          (this.options?.chartOption?.pluginName?.length && this.options?.chartOption?.pluginName?.length > 0)
        ) {
          this.reloadChart()
        }
      }, 0)
    },
    "options.chartOption"(n, o) {
      if (n.reload) {
        this.refreshChart()
        this.$changeOptionsEV(false, "chartOption.reload", false, false, false, true)
      }
    },
    "options.chartOption.refreshTime"(n, o) {
      clearInterval(this.animateTimer)
      this.initRefreshChart(n)
    },
    "options.chartOption.pluginName"(n, o) {
      n = n || []
      o = o || []
      if (!o || n.filter(it => it.length) !== o.filter(it => it.length)) {
        this.reloadChart()
      }
    }
  },
  computed: {
    ids() {
      return this.myid
    },
    isAutoPlayToolTip() {
      return this.options.isAutoPlayToolTip
    },
    autoPlayToolTipIntervalTime() {
      return this.options.autoPlayToolTipIntervalTime
    },
    getChartStyle() {
      if (this.options) {
        return {
          // height: this.options.height + "px",
          height: "100%",
          transform: "rotate(" + this.options.rotate + "deg)",
          opacity: this.options.opacity / 100,
          ...this.getChartCommonStyle
        }
      } else return null
    },
    //  获取图表的样式
    getOption() {
      const opt = this.options.chartOption
      this.initChartPlugins(opt) //初始化图表组件插件系统
      this.initAnimateDelay(opt) //初始化先跳动动画
      return opt
    },
    getInitOptions() {
      return this.options.initOption
    },
    noCacheComponent() {
      return this.options.noCacheComponent
    },
    restDataUrl() {
      return this.options.restDataUrl
    },
    updateTimer() {
      if (!this.options.updateTimer) {
        this.$changeOptionsEV(600, "updateTimer", false, false, false, true)
        return 600 * 1000
      }
      return this.options.updateTimer * 1000
    },
    getDragStatus() {
      return this.$store.state.states.dragStatus
    },
    isEmptyData: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "isEmptyData", "isEmptyData", false)
      },
      set(val) {
        this.$changeOptionsEV(val, "isEmptyData", false, null, this.myid, true)
      }
    },
    errorCode: {
      get() {
        return this.options.errorCode || ""
      },
      set(val) {
        this.$changeOptionsEV(val, "errorCode", false, null, this.myid, true)
      }
    }
  },
  mounted() {
    this.initRefreshChart(this.options.chartOption.refreshTime)
    window.addEventListener("message", this.updateDataFun)

  },
  beforeDestroy() {
    clearInterval(this.animateTimer)
    this.animateTimer = null
    this.removeChartEvent()
    clearInterval(this.reloadTimer)
    clearInterval(this.autoPlayBarTimer)
    window.removeEventListener("message", this.updateDataFun)
  },
  methods: {
    /* 后台监听更新大屏数据 */
    updateDataFun({data}) {
      if (this.isBigScreenPreview() && data.type === "pageInIframeUpdateData") {
        this.refreshFunc()
      }
    },
    checkFormatterValue() {
      let _this = this
      if(!this.options.hasOwnProperty("numberCount")){
        return
      }
      if(_this.options.type === "LiquidFill" && _this.options?.chartOption.getValueIsPercentage){
        return
      }
      const val = this.options?.numberCount || 2
      let series = this.options?.chartOption?.series
      if (series && series.length > 0) {
        let valueUnit = []
        let newSeries = function (params) {
          if(params.seriesType === "liquidFill"){
            let number = 0, str
            if(_this.options?.chartOption.getValueIsPercentage){
              str = "{c}{valueUnit|%}\n{b|{b}}"
            }else{
              let strNumber
              if(params.data.realValue){
                number = getNumber(params.data.realValue)
                strNumber = Number(params.data.realValue)?.toFixed(number)
              } else {
                number = getNumber(params.data.value * params.data.max)
                strNumber = Number(params.data.value * params.data.max)?.toFixed(number)
              }
              str = "{title|"+ strNumber +"}{valueUnit|" + series[params.seriesIndex].unit +"}\n{b|" + params.name + "}"
            }
            return str
          } else if(params.seriesType === "pie"){
            let str
            let number = getNumber(params.value)
            let strNumber = Number(params.value)?.toFixed(number)
            let formatterTypeNumber = series[params.seriesIndex].label.formatterTypeNumber || 1
            if(formatterTypeNumber === 1){
              str = params.name
            }else if(formatterTypeNumber === 2){
              str = params.percent + "%"
            }else if(formatterTypeNumber === 3){
              str = params.name + ":" + params.percent + "%"
            }else if(formatterTypeNumber === 4){
              str = strNumber + ":" + params.percent + "%"
            }else if(formatterTypeNumber === 5){
              str = params.name + ":" + strNumber
            }
            return str
          } else {
            const number = getNumber(params.value)
            let str
            if(_this.options.type === "Radar"){
              str = Number(params.value)?.toFixed(number) + valueUnit[params.seriesIndex]
            }else{
              str = "{title|"+ Number(params.value)?.toFixed(number) +"}{valueUnit|" + valueUnit[params.seriesIndex]+"}"
            }
            return str
          }
        }
        let newToolTip = function (params) {
          if(_this.options.type === "Radar"){
            let indicator = _this.options.chartOption.radar.indicator
            let str = params.name + "</br>"
            indicator.forEach((item, index) => {
              let number = getNumber(params.value[index])
              str += params.marker + "【" + item.name + "】" + "<span style='float: right;margin-left: 20px;'>" + Number(params.value[index])?.toFixed(number) + "</span></br>"
            })
            return str
          } else if(params.seriesType === "liquidFill"){
            let number = getNumber(params.data.realValue)
            let str = params.marker + params.name + "<span style='float: right;margin-left: 20px;'>" + Number(params.data.realValue)?.toFixed(number) + "</span>"
            return str
          } else if(params.seriesType === "pie"){
            let number = getNumber(params.value)
            let str = params.marker + params.name + "<span style='float: right;margin-left: 20px;'>" + Number(params.value)?.toFixed(number) + "</span>"
            return str
          } else {
            const number = getNumber(params[0].value)
            let str = params[0].axisValue + "</br>"
            params.forEach(item => {
              str += item.marker + item.seriesName + '<span style="margin-left:30px;float:right;">' + Number(item.value)?.toFixed(number) + '</span>' + "</br>"
            })
            return str
          }
        }
        function getNumber(value) {
          // 获取小数点个数
          if (!value) return 0
          const arr = value?.toString()?.split(".")
          const numStr = arr && arr.length > 1 ? arr[1].length : 0
          const number = numStr < val ? numStr : val
          return number
        }
        if(_this.options.type === "Radar"){
          series = series[0].data
        }
        series.forEach((item, index) => {
          // if (item.type === "line") return
          let chartArr = ["bar", "pictorialBar", "line"]
          if(chartArr.indexOf(item.type) > -1 && !item.label?.show){
            return
          }
          let formatter = item.label?.formatter
          if(!formatter){  //存在formatter为undefined的情况
            formatter = newSeries
            if(_this.options.type === "pie3D" && index < series.length - 1){
              return
            }
          }
          if (item.hasOwnProperty("unit")) {
            valueUnit[index] = item.unit
          } else if (typeof formatter !== "function") {
            const start = formatter.indexOf("|") + 1
            valueUnit[index] = formatter.slice(start, -1)
            if(_this.options.type === "Radar" && start === 0){
              valueUnit[index] = ""
            } else if(_this.options.type === "LiquidFill"){
              if(_this.options?.chartOption.getValueIsPercentage){
                valueUnit[index] = "%"
              }else{
                valueUnit[index] = ""
              }
            }
          } else {
            valueUnit[index] = ""
            if(this.options.type === "Radar"){
              this.$changeOptionsEV("", "chartOption.series.0.data." + index + ".unit", false, false, false, true)
            }else if(_this.options.type !== "Pie" && _this.options.type !== "pie3D"){
              this.$changeOptionsEV("", "chartOption.series." + index + ".unit", false, false, false, true)
            }
          }
          item.unit = valueUnit[index]
          if(_this.options.type === "Radar"){
            this.$changeOptionsEV(
                newSeries,
                "chartOption.series.0.data." + index + ".label.formatter",
                false,
                false,
                false,
                true)
          }else{
            this.$changeOptionsEV(
                newSeries, "chartOption.series." + index + ".label.formatter",
                false,
                false,
                false,
                true)
          }
        })
        if(_this.options.chartOption.tooltip.show) {
          this.$changeOptionsEV(newToolTip, "chartOption.tooltip.formatter", false, false, false, true)
        }
      }
    },
    mouseoverEv(e) {
      //使用示范
      console.log("mouseoverEv", e)
    },
    /**
     * @param {string} eventType eventCallbackBus中对应的事件类型
     * @param {object} event echarts的事件传参
     */
    dispatchEventCallback(eventType, event) {
      this.eventCallbackList[eventType]?.forEach(functionName => {
        //函数名带点，说明是插件事件，需要for循环定位到handle
        if (functionName.includes(".")) {
          //如果没找到 说明当前没有注册了这个插件 就不需要执行
          if (
            functionName.indexOf("eventControl") === 0 ||
            this.chartOption.pluginNames.find(item => functionName.includes(item.slice(0, -6)))
          ) {
            let func = undefined
            let nameSplit = functionName.split(".")
            //将eventCallbackList中对应的时间名字符串拆分后，循环寻址到对应的函数，再执行
            nameSplit.some((tempPointer, pointerIndex) => {
              if (pointerIndex === 0) {
                func = this[tempPointer]
              } else {
                func = func[tempPointer]
              }
              //当找不到当前函数指针对应的函数时，说明当前组件没有用当前插件，则直接return true 跳出循环
              if (!func) {
                return true
              }
            })

            if (func) func(event)
          }
        } else {
          //不带点 说明是公共当方法 没在插件里
          this[functionName] && this[functionName](event)
        }
      })
    },
    //初始化图表组件插件机制
    initChartPlugins(opt) {
      const _opt = opt || this.options.chartOption
      if (_opt.pluginName && _opt.pluginName.length) {
        //各自调用各自组件内部的插件初始化机制
        // this[`init${this.$vnode.tag.slice(-3)}Plugin`](opt)
        const plugins = [...this.options.chartOption.pluginName].filter(it => it.trim().length)
        const fetchTag = "fetch-"
        plugins.forEach(pluginName => {
          if (this.hasProperty(this, pluginName) && typeof this[pluginName] === "function") {
            this[pluginName](opt)
          } else if (pluginName.includes(fetchTag) && pluginName.length > fetchTag.length) {
            execPluginsFetch.call(this, pluginName, [opt], fetchTag)
          }
        })
      }
    },
    initAnimateDelay(opt) {
      if (!opt.series[0]) return
      opt.series[0].animationDelay = function (idx) {
        return idx * 10 + 100
      }
    },
    // initFormateFunc(opt) {
    //   if (this.hasProperty(opt, "yAxis.axisLabel.formatterEv")) {
    //     eval(opt.yAxis.axisLabel.formatterEv)
    //   }
    // },
    initRefreshChart(time) {
      this.animateTimer = setInterval(() => {
        this.refreshChart()
      }, time)
    },
    refreshChart() {
      this.$nextTick(() => {
        this.refreshedChart = false
        this.$nextTick(() => {
          this.refreshedChart = true
        })
      })
    },
    reloadChart() {
      this.$nextTick(() => {
        this.showChart = false
        this.$nextTick(() => {
          this.showChart = true
        })
      })
    },
    // 拖拽模式的时候屏蔽掉图表悬浮事件
    getDragStatusHandle(newVal, oldVal, type) {
      let hasFunc = false, formatter
      if(this.options.type === "Pie" && this.getOption.series[0]?.label?.formatter && typeof this.getOption.series[0]?.label?.formatter === "function"){
        hasFunc = true
        formatter = this.getOption.series[0]?.label?.formatter
      }
      if (newVal && this.getOption.tooltip.show) {
        const temp = JSON.parse(JSON.stringify(this.getOption))
        temp.tooltip.show = false
        if (this.$refs[type] && this.$refs[type].setOption) {
          if(hasFunc){
            temp.series[0].label.formatter = formatter
          }
          this.$refs[type].setOption(temp, true)
        }
      } else if (!newVal) {
        const temp = JSON.parse(JSON.stringify(this.getOption))
        temp.tooltip.show = true
        if (this.$refs[type] && this.$refs[type].setOption) {
          if(hasFunc){
            temp.series[0].label.formatter = formatter
          }
          this.$refs[type].setOption(temp, true)
        }
      }
    },
    // 图形是否在监听其他数据的变更
    addChartEvent() {
      this.handleChartEvent({ callback: this.updateData.bind(this) })
    },
    removeChartEvent() {
      this.handleChartEvent()
    },
    handleChartEvent(obj) {
      if (window.chartEventBus) {
        const eventMap = window.chartEventBus.eventMap
        const id = `container_id_${this.myid.container_id}-rect_id_${this.myid.rect_id}`
        for (let i in eventMap) {
          if (eventMap[i].includes(id)) {
            obj ? window.chartEventBus.on(i, { ...obj, id }) : window.chartEventBus.off(i, id)
          }
        }
      }
    },
    setAndLoopData() {
      this.updateData()
      this.addChartEvent()
      if (this.isBigScreenPreview() && this.options.autoUpdate !== false) {
        this.reloadTimer = setInterval(() => {
          this.updateData()
          // 给轮询时间加一个不超过5s的随机数，防止多个图表同时请求数据
        }, this.updateTimer + Math.floor(Math.random() * 5000))
      }
    },
    refreshFunc() {
      const rectAttr = this.getAttrById(this.$store.state[this.request_prefix], this.myid)
      const appId = rectAttr?.options?.appId || rectAttr.appId
      if (!appId) return
      //如果appid和restdataurl中的appid不一致，则说明该页面是被克隆出来的，需要重新请请求appid
      if (!this.restDataUrl.includes(appId)) {
        this.$changeOptionsEV(`engine2/data/api-v2/chart/${appId}/data`, "restDataUrl", false, false, false, true)
      }
      this.setAndLoopData()
    },
    changeDatazoomFunc(newVal, oldVal) {
      let yAxisTwo = false
      let yAxisData = this.options.chartOption?.yAxis?.data
      if (this.options.chartOption?.yAxis?.length && this.options.chartOption?.yAxis?.length === 2) {
        yAxisTwo = true
        yAxisData = this.options.chartOption?.yAxis[0]?.data
      }

      if (!newVal) {
        return
      }
      if (newVal.dataLengthAuto === "all") {
        let dataZoom = {
          show: false
          // maxValueSpan :""
        }
        this.$changeOptionsEV(dataZoom, "chartOption.dataZoom", false, false, false, true)
        this.scrollBarAuto()
        this.reloadChart()
      } else if (newVal.dataLengthAuto === "auto" && newVal.dataLength) {
        let data = this.getOption.series[0].data
        if (data.length <= newVal.dataLength) {
          let dataZoom = {
            show: false,
            maxValueSpan: undefined
          }
          this.$changeOptionsEV(dataZoom, "chartOption.dataZoom", false, false, false, true)
          this.scrollBarAuto()
        } else if (!newVal.autoScrollSet) {
          let dataZoom = {
            show: false,
            maxValueSpan: newVal.dataLength - 1
          }
          if (yAxisData && yAxisData.length > 0) {
            dataZoom.orient = "vertical"
          }
          this.$changeOptionsEV(dataZoom, "chartOption.dataZoom", false, false, false, true)
          this.scrollBarAuto()
        } else {
          if (newVal.scrollType === 2) {
            //自动滚动
            let dataZoom = {
              show: true,
              type: "inside",
              disabled: true,
              maxValueSpan: newVal.dataLength - 1
            }
            let yAxisData = this.options.chartOption?.yAxis?.data
            if (yAxisTwo) {
              yAxisData = this.options.chartOption?.yAxis[0]?.data
            }
            if (yAxisData && yAxisData.length > 0) {
              dataZoom.orient = "vertical"
            }
            this.$changeOptionsEV(dataZoom, "chartOption.dataZoom", false, false, false, true)
            setTimeout(() => {
              this.scrollBarAuto()
            }, 500)
          } else {
            //手动滚动
            let dataZoom = {
              show: true,
              maxValueSpan: newVal.dataLength - 1
            }
            if (newVal.showScrollBar) {
              //展示滚动条
              dataZoom.type = "slider"
              dataZoom.backgroundColor = newVal.scrollBarBg
              dataZoom.borderColor = newVal.scrollBarBorderColor
              if (yAxisData && yAxisData.length > 0) {
                dataZoom.width = newVal.scrollBarWidth || 30
                dataZoom.height = (newVal.scrollBarHeight || 100) + "%"
              } else {
                dataZoom.width = (newVal.scrollBarWidth || 100) + "%"
                dataZoom.height = newVal.scrollBarHeight || 30
              }
              //边距调整
              if (newVal.scrollPaddingAuto) {
                dataZoom.top = (newVal.scrollPaddingTop || 0) + "%"
                dataZoom.left = (newVal.scrollPaddingLeft || 0) + "%"
              } else {
                if (dataZoom.hasOwnProperty("top")) {
                  delete dataZoom.top
                }
                if (dataZoom.hasOwnProperty("left")) {
                  delete dataZoom.left
                }
              }
            } else {
              //隐藏滚动条
              dataZoom.type = "inside"
            }
            if (yAxisData && yAxisData.length > 0) {
              dataZoom.orient = "vertical"
            }
            this.$changeOptionsEV(dataZoom, "chartOption.dataZoom", false, false, false, true)
            //清除自动滚动的定时器
            clearInterval(this.autoPlayBarTimer)
            this.autoPlayBarTimer = null
            if (newVal.scrollPaddingAuto === false) {
              this.reloadChart()
            }
          }
        }
      }
    },
    scrollBarAuto() {
      clearInterval(this.autoPlayBarTimer)
      this.autoPlayBarTimer = null
      if (
        this.getOption?.dataZoomSet?.dataLengthAuto === "all" ||
        !this.getOption?.dataZoomSet?.autoScrollSet ||
        this.getOption.dataZoomSet?.scrollType !== 2
      ) {
        return
      }
      let data = this.getOption.series[0].data
      if (data.length <= this.getOption.dataZoomSet.dataLength) {
        return
      }
      let yAxisData = this.options.chartOption?.yAxis?.data
      if (this.options.chartOption?.yAxis?.length && this.options.chartOption?.yAxis?.length === 2) {
        yAxisData = this.options.chartOption?.yAxis[0]?.data
      }
      // 自动播放 tooltip 初始化
      let numberIndex = 0
      this.autoPlayBarTimer = setInterval(() => {
        let dataZoom = {
          type: "inside",
          disabled: true,
          maxValueSpan: this.getOption.dataZoomSet.dataLength - 1,
          startValue: numberIndex,
          endValue: numberIndex + this.getOption.dataZoomSet.dataLength
        }
        if (yAxisData && yAxisData.length > 0) {
          dataZoom.orient = "vertical"
        }
        this.$changeOptionsEV(dataZoom, "chartOption.dataZoom", false, false, false, true)
        numberIndex++
        if (numberIndex + Number(this.getOption.dataZoomSet.dataLength) > data.length) {
          numberIndex = 0
        }
      }, (this.getOption.dataZoomSet.autoScrollTime || 1) * 1000)
    }
  }
}
